import React from 'react';
import type {ItemDefinitionSimpleResponse} from 'src/api/ProactApiClient';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';

import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {SidebarLinkItemTracker} from 'src/app/layout/Sidebar/SidebarLinksConfig';
import {ItemDefinitionTable} from 'src/app/item-tracker/ItemDefinitionTable/ItemDefinitionTable';
import {itemDefinitionDocumentTitle} from 'src/app/item-tracker/itemDefinitionHelpers';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {useModulePermissions} from 'src/shared/auth/permissions/useModulePermissions';

import {routeRegistry} from 'src/pages/RouteRegistry';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

const ItemDefinitionListPage: React.FC = () => {
  useSetDocumentTitle(itemDefinitionDocumentTitle);

  const navigate = useAppNavigate();
  const itemDefPerms = useModulePermissions(ModuleEnum.ItemTrackerDefinitions);

  const handleAddNew = () => navigate(PathUtility.ItemDefinitionCreate());

  const handleNavigateTo = (row: ItemDefinitionSimpleResponse) =>
    navigate(PathUtility.ItemDefinitionView(row.id, 'content'));

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.ItemTracker}>
      <PageHeader>
        <PageHeader.Title icon={SidebarLinkItemTracker.icon}>
          Item Tracker (Manage)
        </PageHeader.Title>
      </PageHeader>
      <ItemDefinitionTable
        identifier="manage-items-table"
        onViewRowClick={handleNavigateTo}
        onCreate={itemDefPerms.create ? handleAddNew : undefined}
      />
    </ContentWrapper>
  );
};

export default ItemDefinitionListPage;

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.ItemDefinitions(),
  element: <ItemDefinitionListPage />,
  isPrivate: true,
  module: ModuleEnum.ItemTrackerDefinitions,
  operation: PermissionOperationEnum.View,
});
